// The Meta Pixel id this build reports to, or "" for none.
//
// ⚠️ A deployed build fires the Pixel only on production. Every deployed build
// loads the committed .env.production, which carries the production Pixel, and
// apphosting.test.yaml / apphosting.demo.yaml layer over apphosting.yaml, so
// test and demo inherit it unless overridden — and App Hosting refuses an empty
// `value: ""`, so it can't be overridden to nothing. Test signups were counting
// as conversions in the live signup campaign. Locally NEXT_PUBLIC_RELEASE_STAGE
// is unset, and whatever .env.development configures (the test Pixel) is used.
//
// Import-free: shared by the client Pixel and the Conversions API route.

export function metaPixelId(): string {
  const stage = process.env.NEXT_PUBLIC_RELEASE_STAGE || "";
  if (stage && stage !== "production") return "";
  return process.env.NEXT_PUBLIC_META_PIXEL_ID || "";
}
